@if (
  (abilities.viewOffers && abilities.viewCandidates) ||
  (abilities.manageJobsReferralSettings && hasReferrals)
) {
  <rt-activity-subscriptions-table [types]="types" [title]="title">
    @if (abilities.viewOffers && abilities.viewCandidates) {
      <rt-activity-subscriptions-table-row
        icon="person"
        [title]="'app.subscriptions.events_group.candidate_apply_v2' | translate"
        [activitySubscriptions]="activitySubscriptions"
        [types]="types"
        [eventsGroup]="['candidateApply']"
        (changeEvents)="changeEvents.emit($event)"
      >
      </rt-activity-subscriptions-table-row>
    }
    @if (abilities.viewOffers && abilities.viewCandidates) {
      <rt-activity-subscriptions-table-row
        icon="merge-type"
        [title]="'app.subscriptions.events_group.candidate_add_v2' | translate"
        [activitySubscriptions]="activitySubscriptions"
        [types]="types"
        [eventsGroup]="[
          'candidateAdd',
          'candidateImport',
          'candidateImportFromLinkedin',
          'candidateMerge',
        ]"
        (changeEvents)="changeEvents.emit($event)"
      >
      </rt-activity-subscriptions-table-row>
    }
    @if (hasOverdueCandidates && abilities.viewOffers && abilities.viewCandidates) {
      <rt-activity-subscriptions-table-row
        [title]="'app.subscriptions.events_group.candidate_overdue_v2' | translate"
        [activitySubscriptions]="activitySubscriptions"
        [types]="types"
        [eventsGroup]="['jobOverdueCandidates']"
        [notifyInfo]="true"
        (changeEvents)="changeEvents.emit($event)"
        icon="alarm"
      ></rt-activity-subscriptions-table-row>
    }
    @if (abilities.viewOffers && abilities.viewCandidates) {
      <rt-activity-subscriptions-table-row
        icon="remove-red-eye"
        [title]="'app.subscriptions.events_group.job_status_change_v2' | translate"
        [activitySubscriptions]="activitySubscriptions"
        [types]="types"
        [eventsGroup]="[
          'jobStatusChange',
          'jobAutoPublishFail',
          'jobAutoCloseFail',
          'jobSchedulerChange',
          'jobStatusAutoChange',
          'jobSchedulerClear',
        ]"
        (changeEvents)="changeEvents.emit($event)"
      >
      </rt-activity-subscriptions-table-row>
    }
    @if (hasRequisitions && abilities.viewRequisitions) {
      <rt-activity-subscriptions-table-row
        icon="remove-red-eye"
        [title]="'app.subscriptions.events_group.requisition_job_published' | translate"
        [activitySubscriptions]="activitySubscriptions"
        [types]="types"
        [eventsGroup]="['jobPublishedRequisitionMismatch']"
        (changeEvents)="changeEvents.emit($event)"
      ></rt-activity-subscriptions-table-row>
    }
    @if (hasReferrals) {
      @if (abilities.manageJobsReferralSettings) {
        <rt-activity-subscriptions-table-row
          icon="navbar-referrals"
          [title]="'app.subscriptions.events_group.referral_offer_status_change_v2' | translate"
          [activitySubscriptions]="activitySubscriptions"
          [types]="types"
          [eventsGroup]="['referralOfferStatusChange']"
          (changeEvents)="changeEvents.emit($event)"
        >
        </rt-activity-subscriptions-table-row>
      }
      @if (abilities.manageJobsReferralSettings) {
        <rt-activity-subscriptions-table-row
          icon="reward"
          [title]="'app.subscriptions.events_group.referral_assign_remove_v2' | translate"
          [activitySubscriptions]="activitySubscriptions"
          [types]="types"
          [eventsGroup]="['referralRewardAssigned', 'referralRewardUnassigned']"
          (changeEvents)="changeEvents.emit($event)"
        >
        </rt-activity-subscriptions-table-row>
      }
      @if (abilities.viewOffers && abilities.viewCandidates) {
        <rt-activity-subscriptions-table-row
          icon="navbar-referrals"
          [title]="'app.subscriptions.events_group.candidate_referred_v2' | translate"
          [activitySubscriptions]="activitySubscriptions"
          [types]="types"
          [eventsGroup]="['candidateReferred']"
          (changeEvents)="changeEvents.emit($event)"
        >
        </rt-activity-subscriptions-table-row>
      }
    }
    @if (abilities.viewAcquisition) {
      <rt-activity-subscriptions-table-row
        icon="bullhorn"
        [title]="'app.subscriptions.events_group.job_posting_change' | translate"
        [activitySubscriptions]="activitySubscriptions"
        [types]="types"
        [eventsGroup]="['jobPostingPublished', 'jobPostingUnpublished']"
        (changeEvents)="changeEvents.emit($event)"
      >
      </rt-activity-subscriptions-table-row>
      <rt-activity-subscriptions-table-row
        icon="bullhorn"
        [title]="'app.subscriptions.events_group.job_campaign_status_change' | translate"
        [activitySubscriptions]="activitySubscriptions"
        [types]="types"
        [eventsGroup]="['jobCampaignCreated', 'jobCampaignEnded', 'jobCampaignProductStatusUpdate']"
        (changeEvents)="changeEvents.emit($event)"
      >
      </rt-activity-subscriptions-table-row>
    }
  </rt-activity-subscriptions-table>
}
